<template>
    <Card>
        <template #header>
            <div class="pl-5 pt-4 font-medium text-[16px]">
                Veiksmų istorija
            </div>
        </template>
        <template #content>
            <ol class="list-decimal px-4">
                <li v-for="action in actionsHistory" :key="action.id"
                    class="mb-2">
                    <div><strong>{{ action.author }}</strong> {{ action.action }}</div>
                    <small class="block text-gray-500">{{ action.created_at }}</small>
                </li>
            </ol>
        </template>
    </Card>
</template>

<script setup lang="ts">
    // System imports
    import { ref, onMounted } from 'vue';
    import { apiRequest } from '@/services/axios.ts'

    import Card from 'primevue/card'

    // Refs and variables
    const actionsHistory = ref<any>([]);

    // Props
    let props = defineProps<{
        contact: any
    }>();

    // Hooks
    onMounted(() => {
        loadActionsHistory();
    });

    async function loadActionsHistory() {
        const response = await apiRequest(
            'get',
            '/contacts/' + props.contact.id + '/actions-history'
        );

        actionsHistory.value = response.data.data.history;
    }
</script>